import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Transform, Type } from "class-transformer";
import { OperativeUnitHasOnCallTypeDto } from "@/core/features/operative-units-have-on-calls/operative-unit-has-on-call-type.dto";
import { toEuros } from "@/utils/numberUtils";
import { BusinessUnitDto } from "@/core/features/business-units/business-unit.dto";
import { UserDto } from "@/core/features/users/user.dto";

export class OperativeUnitDto extends BaseEntityDto {
  code: string;

  name: string;

  archived: boolean;

  businessUnitId?: string | null;

  @Type(() => BusinessUnitDto)
  businessUnit?: BusinessUnitDto;

  responsibleId?: string | null;

  @Type(() => UserDto)
  responsible?: UserDto | null;

  codification?: string;

  /**
   * Hex color string (#RRGGBB). Stored as hex to avoid coupling the API/database to Quasar palette names.
   */
  color: string;

  @Transform(({ value }) => toEuros(value))
  onCallHourlyRate?: number;

  @Transform(({ value }) => toEuros(value))
  onCallActivationPrice?: number;

  isGrProductionApplicable?: boolean;

  @Type(() => OperativeUnitHasOnCallTypeDto)
  operativeUnitHasOnCallTypes?: OperativeUnitHasOnCallTypeDto[];

  toString(): string {
    return this.code;
  }
}
